import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SKIP_GLOBAL_LOADING_HEADER } from '@common/app/constants/http.constants';
import { HttpLoadingService } from '@common/app/services/http-loading.service';

export const httpLoadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.has(SKIP_GLOBAL_LOADING_HEADER)) {
    return next(req);
  }

  const loading = inject(HttpLoadingService);
  loading.begin();

  return next(req).pipe(finalize(() => loading.end()));
};
